module.exports = __webpack_public_path__ + "static/media/rein-on-chair.239830da.svg";